import React, { useEffect  } from "react";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import EventCalendar from "component/dashboard/Calendar";

function Calendar() {
  useEffect(() => {
    document.title = "Green Hill Kemuning | Calendar";
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />            
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y px-4">
                    <h5 class="fw-bold mb-4" style={{ color: "#5a5c69" }}><span class="text-muted fw-light" style={{ color: "#858796" }}>Dashboard /</span> Calendar</h5>
                    <EventCalendar/> 
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
    </div>
  );
}

export default Calendar;
